<template>
    <div>
        <b-modal id="modal-confirm-cancel" title="Konfirmasi Pembatalan SPK" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Batalkan SPK ini? Unit akan diubah kembali statusnya menjadi RETUR.
            <b-form-group label="Keterangan Pembatalan" class="mt-4">
                <b-form-textarea v-model="input.pembatalan" maxlength="100" placeholder="Keterangan..." max-rows="6" rows="3" />
                <div class="text-right">
                    {{ input.pembatalan.length }} / 100
                </div>
            </b-form-group>
            <div class="text-right">
                <b-button variant="danger" :disabled="isSubmitting" @click="executeCancel">
                    {{ isSubmitting ? "Membatalkan..." : "Batalkan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-kirim" title="Konfirmasi Set Kirim" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Set kirim unit ini? Lokasi unit akan berpindah ke Workshop terkait.
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetKirim">
                    {{ isSubmitting ? "Mengirim..." : "Kirim" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-desc-kerja" title="Set Deskripsi Kerja" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Deskripsi Kerja">
                <b-form-textarea v-model="input.deskripsiKerja" maxlength="1000" placeholder="Deskrispi..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.deskripsiKerja.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tipe Pengerjaan">
                <b-form-radio v-model="input.operation" value=1>Repair</b-form-radio>
                <b-form-radio v-model="input.operation" value=2>Overhaul</b-form-radio>
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetDeskripsiKerja">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-approve-bom" title="Approval BOM" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Approve BOM {{ bom.nomorBom }}?
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeApproveBOM">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-reject-bom" title="Reject BOM" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Alasan Penolakan">
                <b-form-input v-model="input.rejectReason" maxlength="200" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeRejectBOM">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-sparepart" title="Set Serah Terima Sparepart BOM Selesai" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nomor DO">
                <b-form-input v-model="input.nomorDo" maxlength="100" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetSparepart">
                    {{ isSubmitting ? "Mengirim..." : "Kirim" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-repair-finished" title="Set Repair Selesai" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan">
                <b-form-textarea v-model="input.catatanFinishRepair" maxlength="1000" placeholder="Catatan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanFinishRepair.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Upload Bukti Hasil Kerja (Opsional)">
                <b-form-file v-model="input.fileHasilKerja" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetRepairFinished">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-acc-repair" title="Approval Repair Selesai" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan">
                <b-form-textarea v-model="input.catatanApprovalRepair" maxlength="500" placeholder="Catatan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanApprovalRepair.length }} / 500
                </div>
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeAccRepair(true)">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-reject-repair" title="Reject Repair Selesai" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Alasan Penolakan">
                <b-form-textarea v-model="input.catatanApprovalRepair" maxlength="500" placeholder="Alasan Penolakan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanApprovalRepair.length }} / 500
                </div>
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeAccRepair(false)">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-return" title="Return Unit" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Kirimkan unit kembali ke warehouse? SPK ini akan dinyatakan selesai (closed), dan unit akan dipindahkan ke WAREHOUSE dengan status READY LINE.
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeReturn">
                    {{ isSubmitting ? "Menyimpan..." : "Return Unit" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-new-bom" title="BOM Baru" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nomor BOM">
                <b-form-input v-model="input.nomorBom" maxlength="100" />
            </b-form-group>
            <b-form-group label="Upload BOM">
                <b-form-file v-model="input.fileBom" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeNewBom">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-ready-bom" title="Set BOM Ready Pick Up" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Nyatakan BOM ini sebagai ready to pick up?
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetReadyBom">
                    {{ isSubmitting ? "Menyimpan..." : "Set Ready" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-berkas-penyelesaian" title="Berkas Laporan Penyelesaian Pekerjaan" centered hide-footer>
            <div v-if="rejection.repairFinishedBy != null"><!-- Alur Kerja Repair -->
                <span style="white-space: pre-line">{{ rejection.catatanFinishRepair }}</span>
                <div class="mt-4 small">
                    {{ rejection.repairFinishedBy }} - {{ $helper.parseDate(rejection.repairFinishedAt) }}, {{ $helper.parseHourMinute(rejection.repairFinishedAt) }}
                </div>
                <a :href="$BASE_FILE_PATH + rejection.pathHasilKerja" download target="_blank">
                    <b-button variant="primary" class="mt-4">
                        <i class="fa fa-download mr-2" /> Download Bukti Hasil Kerja
                    </b-button>
                </a>
            </div>
            <div v-else><!-- Alur Kerja Scrap -->
                <span style="white-space: pre-line">{{ rejection.catatanScrap }}</span>
                <div class="mt-4 small">
                    {{ rejection.scrapListSentBy }} - {{ $helper.parseDate(rejection.scrapListSentAt) }}, {{ $helper.parseHourMinute(rejection.scrapListSentAt) }}
                </div>
                <a :href="$BASE_FILE_PATH + rejection.pathScrapList" download target="_blank">
                    <b-button variant="primary" class="mt-4">
                        <i class="fa fa-download mr-2" /> Download List Sparepart Hasil Salvage / Scrap
                    </b-button>
                </a>
            </div>
        </b-modal>
        <b-modal id="modal-new-document" title="Berkas Baru" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan Berkas">
                <b-form-textarea v-model="input.docNote" maxlength="1000" placeholder="Catatan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.docNote.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Upload Dokumen (Opsional)">
                <b-form-file v-model="input.fileDoc" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeNewDoc">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-new-spb" title="SPB Baru" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nomor SPB">
                <b-form-input v-model="input.nomorSpb" maxlength="100" />
            </b-form-group>
            <b-form-group label="Upload SPB">
                <b-form-file v-model="input.fileSpb" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeNewSpb">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-approve-spb" title="Approval SPB" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Approve SPB {{ spb.nomorSpb }}?
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeApproveSPB">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-reject-spb" title="Reject SPB" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Alasan Penolakan">
                <b-form-input v-model="input.rejectReason" maxlength="200" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeRejectSPB">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-upload-ro-spb" title="Upload RO" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nomor RO">
                <b-form-input v-model="input.nomorRo" maxlength="100" />
            </b-form-group>
            <b-form-group label="Upload RO">
                <b-form-file v-model="input.fileRo" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSpbUploadRo">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-ready-spb" title="Set SPB Ready Pick Up" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Nyatakan SPB ini sebagai ready to pick up?
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetReadySpb">
                    {{ isSubmitting ? "Menyimpan..." : "Set Ready" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-done-spb" title="Set Serah Terima SPB Selesai" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nomor DO">
                <b-form-input v-model="input.nomorDo" maxlength="100" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetDoneSpb">
                    {{ isSubmitting ? "Mengirim..." : "Kirim" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-scrap-list" title="Scrap / Salvage Unit" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan">
                <b-form-textarea v-model="input.catatanScrapList" maxlength="255" placeholder="Catatan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanScrapList.length }} / 255
                </div>
            </b-form-group>
            <b-form-group label="Upload Sparepart Dari Scrap / Salvage">
                <b-form-file v-model="input.fileScrapList" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeSetScrapList">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-acc-scrap" title="Approval Scrap" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Catatan">
                <b-form-textarea v-model="input.catatanApprovalScrap" maxlength="500" placeholder="Catatan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanApprovalScrap.length }} / 500
                </div>
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeAccScrap(true)">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-reject-scrap" title="Reject Scrap" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Alasan Penolakan">
                <b-form-textarea v-model="input.catatanApprovalScrap" maxlength="500" placeholder="Alasan Penolakan..." max-rows="8" rows="4" />
                <div class="text-right">
                    {{ input.catatanApprovalScrap.length }} / 500
                </div>
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeAccScrap(false)">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-take-scrap" title="Nyatakan Sparepart Diterima" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Nyatakan sparepart diterima? SPK ini akan dinyatakan selesai (closed), dan unit akan dipindahkan ke WAREHOUSE dengan status LAINNYA.
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeTakeScrap">
                    {{ isSubmitting ? "Menyimpan..." : "Lanjutkan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'spk-engine-detail-modals',
    props: {
        id: { type: String, required: true },
        bom: { type: Object, required: true },
        spb: { type: Object, required: true },
        rejection: { type: Object, required: true }
    },
    data() {
        return {

            isSubmitting: false,

            input: {
                pembatalan: "",
                deskripsiKerja: "",
                revisiDeskripsiKerja: "",
                catatanSparepart: "",
                catatanFinishRepair: "",
                catatanApprovalRepair: "",
                catatanScrapList: "",
                catatanApprovalScrap: "",
                nomorDo: "",
                nomorBom: "",
                rejectReason: "",
                fileBom: null,
                fileBomRevisi: null,
                fileHasilKerja: null,
                fileScrapList: null,

                operation: 1,

                fileDoc: null,
                docNote: "",

                nomorSpb: "",
                fileSpb: null,
                nomorRo: "",
                fileRo: null,
                nomorDo: ""
            },

        }
    },
    methods: {

        executeCancel() {

            if(this.$helper.isBlank(this.input.pembatalan)) {
                return this.$helper.toastError(this, "Mohon mengisi keterangan pembatalan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("keterangan", this.input.pembatalan)

            this.isSubmitting = true
            this.$axios.post("spk-engine/batal", payload).then(res => {

                this.$helper.toastSuccess(this, "SPK berhasil dibatalkan!")
                this.$bvModal.hide("modal-confirm-cancel")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetKirim() {

            let payload = new FormData()
            payload.append("spkId", this.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/set-kirim", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil dikirimkan ke workshop!")
                this.$bvModal.hide("modal-set-kirim")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetDeskripsiKerja() {

            if(this.$helper.isBlank(this.input.deskripsiKerja)) {
                return this.$helper.toastError(this, "Mohon mengisi deskripsi kerja!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("deskripsiKerja", this.input.deskripsiKerja)
            payload.append("operation", this.input.operation)

            this.isSubmitting = true
            this.$axios.post("spk-engine/set-work", payload).then(res => {

                this.$helper.toastSuccess(this, "Deskripsi kerja berhasil disimpan!")
                this.$bvModal.hide("modal-set-desc-kerja")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeApproveBOM() {

            let payload = new FormData()
            payload.append("bomId", this.bom.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/bom-approval", payload).then(res => {

                this.$helper.toastSuccess(this, "BOM berhasil diterima!")
                this.$bvModal.hide("modal-approve-bom")
                this.$emit('bom-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeRejectBOM() {

            if(this.input.rejectReason.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi alasan penolakan BOM!")
            }

            let payload = new FormData()
            payload.append("bomId", this.bom.id)
            payload.append("reason", this.input.rejectReason)

            this.isSubmitting = true
            this.$axios.post("spk-engine/bom-reject", payload).then(res => {

                this.$helper.toastSuccess(this, "BOM berhasil ditolak!")
                this.$bvModal.hide("modal-reject-bom")
                this.$emit('bom-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetSparepart() {

            if(this.$helper.isBlank(this.input.nomorDo)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor DO!")
            }

            let payload = new FormData()
            payload.append("bomId", this.bom.id)
            payload.append("nomorDo", this.input.nomorDo)

            this.isSubmitting = true
            this.$axios.post("spk-engine/bom-serah-terima", payload).then(res => {

                this.$helper.toastSuccess(this, "Serah terima berhasil disimpan!")
                this.$bvModal.hide("modal-set-sparepart")
                this.$emit('bom-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetRepairFinished() {

            if(this.$helper.isBlank(this.input.catatanFinishRepair)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("catatan", this.input.catatanFinishRepair)

            if(this.input.fileHasilKerja != null) {
                payload.append("buktiHasilKerja", this.input.fileHasilKerja)
            }

            this.isSubmitting = true
            this.$axios.post("spk-engine/set-finish", payload).then(res => {

                this.$helper.toastSuccess(this, "Set selesai berhasil disimpan!")
                this.$bvModal.hide("modal-set-repair-finished")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeAccRepair(isApproved) {

            if(this.$helper.isBlank(this.input.catatanApprovalRepair)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("catatan", this.input.catatanApprovalRepair)
            payload.append("isApproved", isApproved)

            this.isSubmitting = true
            this.$axios.post("spk-engine/approve-reject-work-result", payload).then(res => {

                if(isApproved) {
                    this.$helper.toastSuccess(this, "Repair unit berhasil diapprove!")
                }
                else {
                    this.$helper.toastSuccess(this, "Repair unit berhasil ditolak!")
                }

                this.$bvModal.hide("modal-acc-repair")
                this.$bvModal.hide("modal-reject-repair")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeReturn() {

            let payload = new FormData()
            payload.append("spkId", this.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/return", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil dikirimkan kembali, SPK dinyatakan selesai!")
                this.$bvModal.hide("modal-return")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeNewBom() {

            if(this.input.nomorBom.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi nomor BOM!")
            }

            if(this.input.fileBom == null) {
                return this.$helper.toastError(this, "Mohon mengupload BOM!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("noBom", this.input.nomorBom)
            payload.append("file", this.input.fileBom)

            this.isSubmitting = true
            this.$axios.post("spk-engine/bom-baru", payload).then(res => {

                this.$helper.toastSuccess(this, "BOM baru berhasil ditambahkan!")
                this.$bvModal.hide("modal-new-bom")
                this.$emit('new-bom', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetReadyBom() {

            let payload = new FormData()
            payload.append("bomId", this.bom.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/bom-set-ready", payload).then(res => {

                this.$helper.toastSuccess(this, "BOM berhasil dinyatakan ready!")
                this.$bvModal.hide("modal-set-ready-bom")
                this.$emit('bom-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeNewDoc() {

            if(this.input.docNote.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("notes", this.input.docNote)

            if(this.input.fileDoc != null) {
                payload.append("file", this.input.fileDoc)
            }

            this.isSubmitting = true
            this.$axios.post("spk-engine/document-new", payload).then(res => {

                this.$helper.toastSuccess(this, "Dokumen baru berhasil ditambahkan!")
                this.$bvModal.hide("modal-new-document")

                this.input.fileDoc = null
                this.$emit('new-doc', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeNewSpb() {

            if(this.input.nomorSpb.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi nomor SPB!")
            }

            if(this.input.fileSpb == null) {
                return this.$helper.toastError(this, "Mohon mengupload SPB!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("nomorSpb", this.input.nomorSpb)
            payload.append("fileSpb", this.input.fileSpb)

            this.isSubmitting = true
            this.$axios.post("spk-engine/spb-create", payload).then(res => {

                this.$helper.toastSuccess(this, "SPB baru berhasil ditambahkan!")
                this.$bvModal.hide("modal-new-spb")
                this.$emit('new-spb', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeApproveSPB() {

            let payload = new FormData()
            payload.append("spbId", this.spb.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/spb-approve", payload).then(res => {

                this.$helper.toastSuccess(this, "SPB berhasil diterima!")
                this.$bvModal.hide("modal-approve-spb")
                this.$emit('spb-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeRejectSPB() {

            if(this.input.rejectReason.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi alasan penolakan SPB!")
            }

            let payload = new FormData()
            payload.append("spbId", this.spb.id)
            payload.append("reason", this.input.rejectReason)

            let path = "spk-engine/spb-reject"
            if(this.spb.status == 2) { // Status menunggu upload RO
                path = "spk-engine/spb-reject-on-ro"
            }

            this.isSubmitting = true
            this.$axios.post(path, payload).then(res => {

                this.$helper.toastSuccess(this, "SPB berhasil ditolak!")
                this.$bvModal.hide("modal-reject-spb")
                this.$emit('spb-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSpbUploadRo() {

            if(this.input.nomorRo.trim() == "") {
                return this.$helper.toastError(this, "Mohon mengisi nomor RO!")
            }

            if(this.input.fileRo == null) {
                return this.$helper.toastError(this, "Mohon mengupload RO!")
            }

            let payload = new FormData()
            payload.append("spbId", this.spb.id)
            payload.append("nomorRo", this.input.nomorRo)
            payload.append("fileRo", this.input.fileRo)

            this.isSubmitting = true
            this.$axios.post("spk-engine/spb-upload-ro", payload).then(res => {

                this.$helper.toastSuccess(this, "RO berhasil diupload!")
                this.$bvModal.hide("modal-upload-ro-spb")
                this.$emit('spb-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetReadySpb() {

            let payload = new FormData()
            payload.append("spbId", this.spb.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/spb-ready-pickup", payload).then(res => {

                this.$helper.toastSuccess(this, "SPB berhasil dinyatakan ready!")
                this.$bvModal.hide("modal-set-ready-spb")
                this.$emit('spb-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetDoneSpb() {

            if(this.$helper.isBlank(this.input.nomorDo)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor DO!")
            }

            let payload = new FormData()
            payload.append("spbId", this.spb.id)
            payload.append("nomorDo", this.input.nomorDo)

            this.isSubmitting = true
            this.$axios.post("spk-engine/spb-done", payload).then(res => {

                this.$helper.toastSuccess(this, "Serah terima berhasil disimpan!")
                this.$bvModal.hide("modal-set-done-spb")
                this.$emit('spb-updated', res.data)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetScrapList() {

            if(this.$helper.isBlank(this.input.catatanScrapList)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("catatan", this.input.catatanScrapList)

            if(this.input.fileScrapList != null) {
                payload.append("scrapList", this.input.fileScrapList)
            }

            this.isSubmitting = true
            this.$axios.post("spk-engine/set-scrap-list", payload).then(res => {

                this.$helper.toastSuccess(this, "Set scrap / salvage unit berhasil!")
                this.$bvModal.hide("modal-set-scrap-list")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeAccScrap(isApproved) {

            if(this.$helper.isBlank(this.input.catatanApprovalScrap)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            let payload = new FormData()
            payload.append("spkId", this.id)
            payload.append("catatan", this.input.catatanApprovalScrap)
            payload.append("isApproved", isApproved)

            this.isSubmitting = true
            this.$axios.post("spk-engine/approve-reject-scrap-list", payload).then(res => {

                if(isApproved) {
                    this.$helper.toastSuccess(this, "Scrap berhasil diapprove!")
                }
                else {
                    this.$helper.toastSuccess(this, "Scrap berhasil ditolak!")
                }

                this.$bvModal.hide("modal-acc-scrap")
                this.$bvModal.hide("modal-reject-scrap")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeTakeScrap() {

            let payload = new FormData()
            payload.append("spkId", this.id)

            this.isSubmitting = true
            this.$axios.post("spk-engine/scrap-received", payload).then(res => {

                this.$helper.toastSuccess(this, "Sparepart berhasil diterima, unit berhasil discrap. SPK dinyatakan selesai!")
                this.$bvModal.hide("modal-take-scrap")
                this.$emit('refresh')

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

    },
    created() {

    }
}
</script>
